<template>
  <div class="login-new" :class="bgColor">
    <div class="title">{{ $t("login.title") }}</div>
    <Tabs :activeId="tabsActive" :showOnlyPassword="showOnlyPassword" @change="change" />
    <div class="main" :class="{agreementAni: isShowAgreementAni}">
      <LoginPassword
        v-show="tabsActive == 1"
        ref="loginPassword"
        :userInfo="getLocalUserInfoData && getLocalUserInfoData.userInfo ? getLocalUserInfoData.userInfo : '' "
        @handleInputAccount="handleInputAccount"
        >
      </LoginPassword>
      <LoginMessage
        v-if="tabsActive == 2"
        ref="loginMessage"
        :userInfo="getLocalUserInfoData && getLocalUserInfoData.userInfo ? getLocalUserInfoData.userInfo : '' ">

      </LoginMessage>
      <!--   忘记密码 注册   -->
      <div class="link-box">
        <div class="item" @click="toForgetPassword">
          <!-- {{ $t("login.forget_password_text") }} -->
          {{ $t('m000029') }}
        </div>
        <div class="item" v-if="!showOnlyPassword">
          {{ $t("login.register_text_prev") }}
          <span class="link" @click="toRegister">{{
            $t("login.register_text_next")
          }}</span>
        </div>
      </div>
    </div>

    <!-- 生物识别登录入口：当满足以下所有条件时显示
         1. biometricStatus存在且type大于0（设备支持生物识别）
         2. 存在token
         3. 生物识别功能已启用（status为true）
         4. 当前账户与本地存储账户一致（isSameAccount为true）
    -->
    <div
      v-if="biometricStatus && biometricStatus.type > 0 && getLocalUserInfoData.token && biometricStatus.status && isSameAccount"
      class="faceId-box"
      @click="JSBCheckBiometric"
    >
      {{ $t("login.faceIDOrFingerprint") }}
    </div>

    <!-- 添加 van-action-sheet 组件 -->
    <van-action-sheet
      v-model="showActionSheet"
      :actions="actions"
      :cancel-text="$t('openAccount.t000028')"
      close-on-click-action
      @cancel="onCancel"
      @select="onSelect"
    />

    <!-- 新增全局客服弹层组件 -->
    <GlobalActionSheet v-if="showGlobalSheet" v-model="showGlobalSheet" @close="onGlobalClose" />
  </div>
</template>

<script>
import Tabs from "./components/Tabs.vue";
import LoginPassword from "./components/LoginPassword.vue";
import LoginMessage from "./components/LoginMessage.vue";
import { getBrowser } from "@/utils/browser";
import { login } from "@/utils/hybirdMethods";
import { Toast, ActionSheet } from "vant";
import GlobalActionSheet from "@/components/GlobalActionSheet.vue";
export default {
  components: {
    Tabs,
    LoginPassword,
    LoginMessage,
    [ActionSheet.name]: ActionSheet,
    GlobalActionSheet
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    // 获取URL参数
    urlParams() {
      const { loginType, loginUserId } = this.$route.query;
      return {
        loginType: loginType || '',
        loginUserId: loginUserId || ''
      };
    },
    // 是否只显示密码登录
    showOnlyPassword() {
      return this.urlParams.loginType === '1';
    }
  },
  data() {
    return {
      tabsActive: 1, // 当前选中 tabs
      biometricStatus: "", // 设备信息
      getLocalUserInfoData: {},  // app端获取到的用户信息
      isShowAgreementAni: false, // 处理 免责申明 动画的
      showActionSheet: false, // action-sheet 显示状态
      actions: [
        { name: this.$t('m000030'), type: 1 },
        { name: this.$t('m000031'), type: 2 }
      ],
      showGlobalSheet: false, // 全局客服弹层显示状态
      isFromUrl: false, // 是否来自URL参数
      isSameAccount: true, // 账号与本地user_id是否一致
      accountTimer: null // 账号输入防抖定时器
    };
  },
  created() {
    this.getUserInfoForApp();
    this.getBiometricStatus(); // 获取设备信息
  },
  mounted() {

    // login_mode 1 密码 2 验证码 3 生物识别
    this.$getStorageApp("login_mode",(e) =>{
      if(e == 3){
        // 如果传了loginType就不弹出指纹验证
        if (this.urlParams.loginType == 1) return false;
        this.tabsActive = 1;
        this.getBiometricStatus()
        if(this.tabsActive == 1){
          this.$refs.loginPassword.isCheckAgreement = true;
        }else if(this.tabsActive == 2){
          this.$refs.loginMessage.isCheckAgreement = true;
        }
        setTimeout(()=>{
          if(this.biometricStatus){
            this.JSBCheckBiometric();
          }
        },100)
      }else{
        // 如果是loginType等于1，则使用密码登录模式，否则原逻辑执行
        this.tabsActive = this.urlParams.loginType === '1' ? 1 : (e || 1);
      }
    });
  },
  methods: {
    // 切换顶部tab
    change(id) {
      this.tabsActive = id;
      this.$setStorageApp("login_mode", id);
    },
    // 获取uid + token
    getUserInfoForApp(){
      // 如果URL上有loginType=1则只显示单tab
      if (this.urlParams.loginType == 1) {
        this.isFromUrl = true;
        // 如果有loginUserId则优先使用loginUserId
        if ( this.urlParams.loginUserId != '' ) {
          this.getLocalUserInfoData = {
            userInfo: {
              user_id: this.urlParams.loginUserId
            }
          };
        }
        return;
      }

      this.$JsBridge.callHandler("getLocalUserInfo", '', res => {
        res = JSON.parse(res);
        this.getLocalUserInfoData = res;
      });
    },
    // 忘记密码
    toForgetPassword() {
      this.showActionSheet = true;
    },
    toRegister() {
      this.$router.push({
        path: "register",
        query: {
          open: this.$route.query.open
        }
      }).catch(err => {
        
      });
    },
    getBiometricStatus() {
      if (getBrowser().isApp) {
        this.$JsBridge.callHandler("getBiometricStatus", "", res => {
          res = JSON.parse(res);
          this.biometricStatus = res;
        });
      }
    },
    // 开启设备验证
    JSBCheckBiometric() {
      // 校验一下 是否 勾选 免责申明
      let isCheckAgreement = false;
      if(this.tabsActive == 1){
        isCheckAgreement = this.$refs.loginPassword.isCheckAgreement;
      }else if(this.tabsActive == 2){
        isCheckAgreement = this.$refs.loginMessage.isCheckAgreement;
      }
      if (!isCheckAgreement) {
        clearTimeout(this.agreementAniInter);
        Toast(this.$t("login.isCheckAgreementTips"));
        this.isShowAgreementAni = true;
        this.agreementAniInter = setTimeout(() => {
          this.isShowAgreementAni = false;
        }, 600);
        return false;
      }
      this.$JsBridge.callHandler("checkBiometric", "", res => {
        res = JSON.parse(res);
        if (res.result) {
          this.getUserInfoForApp(); // 再获取一遍 token
          this.$apis.authLoginV2FingerprintApi('',{
              get: {
                Authorization: "Bearer " + this.getLocalUserInfoData.token
              }
          }).then(res => {
              const { token, user_info } = res;
              this.$localstorage.set("userInfo", user_info);
              sessionStorage.setItem("token", token);
              this.$setStorageApp("login_mode", 3);
              // 登录成功
              if (getBrowser().isApp) {
                login(res);
              } else {
                this.$router.go(-1);
              }
          })
        }
      });
    },

    // 取消操作
    onCancel() {
      this.showActionSheet = false;
    },

    // 选择操作
    onSelect(action) {
      if (action.type === 1) {
        this.$router.push({
          path: "/login-password-forget",
          query: { h5: "true" }
        });
      } else if (action.type === 2) {
        // 关闭原 actionSheet，打开全局客服弹层
        this.showActionSheet = false;
        this.showGlobalSheet = true;
      }
    },

    // 全局客服弹层关闭回退
    onGlobalClose() {
      this.showGlobalSheet = false;
      this.showActionSheet = true;
    },
    // 处理账号输入事件，用于判断当前输入的账号是否与本地存储的用户ID一致
    handleInputAccount(account) {
      clearTimeout(this.accountTimer);
      this.accountTimer = setTimeout(() => {
        const localId = this.getLocalUserInfoData && this.getLocalUserInfoData.userInfo ? this.getLocalUserInfoData.userInfo.user_id : '';
        this.isSameAccount = account == localId;
      }, 200);
    }
  }
};
</script>

<style scoped lang="less">
@import "./components/form.comon.less";
</style>
